export interface ParsedSseEvent {
  readonly id?: string;
  readonly event?: string;
  readonly retry?: number;
  readonly data: string;
}

/** Incremental parser: network chunks do not necessarily align with SSE events. */
export class WalletSseParser {
  private buffer = "";

  push(chunk: string): ParsedSseEvent[] {
    this.buffer += chunk;
    const blocks = this.buffer.split(/\r?\n\r?\n/);
    this.buffer = blocks.pop() ?? "";
    return blocks
      .map((block) => this.parseBlock(block))
      .filter((event): event is ParsedSseEvent => event !== null);
  }

  reset(): void {
    this.buffer = "";
  }

  private parseBlock(block: string): ParsedSseEvent | null {
    let id: string | undefined;
    let event: string | undefined;
    let retry: number | undefined;
    const data: string[] = [];

    for (const rawLine of block.split(/\r?\n/)) {
      const line = rawLine.replace(/^\uFEFF/, "");
      if (!line || line.startsWith(":")) continue;

      const separator = line.indexOf(":");
      const field = separator === -1 ? line : line.slice(0, separator);
      const value = separator === -1
        ? ""
        : line.slice(separator + 1).replace(/^ /, "");

      if (field === "data") data.push(value);
      else if (field === "id" && !value.includes("\0")) id = value;
      else if (field === "event") event = value;
      else if (field === "retry" && /^\d+$/.test(value)) retry = Number(value);
    }

    if (data.length === 0) return null;
    return { id, event, retry, data: data.join("\n") };
  }
}

